// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2937) return "static/chunks/eabe11fc-ce6fdd1a17cad468.js";
	if (chunkId === 7009) return "static/chunks/7009-f5a01ddc2ae11eb1.js";
	if (chunkId === 8496) return "static/chunks/8496-f898dc7db7ec9c92.js";
	if (chunkId === 1745) return "static/chunks/1745-7c5b554f080abd04.js";
	if (chunkId === 1052) return "static/chunks/1052-4b484b6783db02f4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2723":"0c9dcbbe","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"1167":"d24a80ca66233d62","1473":"8c0129530edaad32","2723":"9432b060eae42b65","3154":"0e726d2444fa7dbd","4627":"c0f04a7c9fc0d447","5279":"825d8c7f83f3c061","5414":"06434c6e4a7ade75","5696":"42ca9cb8f7fe4602","7229":"4a5cf677c74fc8eb","8757":"14755ce603820f53","9608":"895d542a45199e7c"}[chunkId] + ".js";
};